// Partner profile rules (the backend checks the same formats).

export const onlyDigits = (value, max) => String(value || "").replace(/\D/g, "").slice(0, max);

export const isValidAadhar = (v) => /^\d{12}$/.test(String(v || ""));
export const isValidMobile = (v) => /^\d{10}$/.test(String(v || ""));

// First problem with the profile's required fields, or null when complete
export const profileError = (vd = {}) => {
    if (!isValidAadhar(vd.aadharNumber)) return "Aadhaar number must be exactly 12 digits.";
    if (!isValidMobile(vd.aadharLinkedPhoneNumber)) return "Aadhaar-linked mobile must be exactly 10 digits.";
    return null;
};
